export const useAssetFilter = (assetId?: string, filter: any = {}) => {
  if (assetId) {
    filter.asset = { eq: assetId };
  }

  return filter;
};
